import { ArrowUpRight, SlidersHorizontal } from "lucide-react";
import { Reveal } from "./Reveal";
import { CATEGORIES, CATEGORIES_INTRO, CONFIG_NOTE, LINKS } from "../data/site";

export const Categories = () => (
  <section id="valasztek" data-testid="categories-section" className="scroll-mt-24 py-24 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-12 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
        <div className="max-w-2xl">
          <p className="eyebrow mb-3">{CATEGORIES_INTRO.eyebrow}</p>
          <h2 className="font-display text-3xl font-semibold leading-tight text-ink sm:text-5xl">
            {CATEGORIES_INTRO.title}
          </h2>
        </div>
        <a
          href={LINKS.mainSite}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="categories-webshop-link"
          className="inline-flex shrink-0 items-center gap-1.5 text-sm font-bold text-burgundy underline-offset-4 hover:underline"
        >
          {CATEGORIES_INTRO.linkLabel}
          <ArrowUpRight className="h-4 w-4" />
        </a>
      </Reveal>

      <div className="grid gap-5 md:auto-rows-[255px] md:grid-cols-3">
        {CATEGORIES.map((cat, i) => (
          <Reveal
            key={cat.title}
            delay={(i % 3) * 0.08}
            className={i === 0 ? "md:col-span-2 md:row-span-2" : ""}
          >
            <div
              data-testid={`category-card-${i}`}
              className="group relative block h-full min-h-[260px] overflow-hidden rounded-3xl bg-night card-shadow"
            >
              <img
                src={cat.img}
                alt={cat.alt}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-night/85 via-night/20 to-night/5" />
              <span className="absolute left-5 top-5 rounded-full bg-gold px-3.5 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.16em] text-night">
                {cat.badge}
              </span>
              <div className="absolute inset-x-0 bottom-0 p-6">
                <h3 className="font-display text-xl font-semibold text-white sm:text-2xl">{cat.title}</h3>
                <p className="mt-1 max-w-sm text-sm text-white/80">{cat.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div
          data-testid="custom-config-note"
          className="mt-6 flex items-start gap-4 rounded-3xl border border-line bg-white p-6 card-shadow"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-burgundy/10 text-burgundy">
            <SlidersHorizontal className="h-5 w-5" />
          </span>
          <p className="text-sm leading-relaxed text-soft sm:text-base">
            <strong className="text-ink">{CONFIG_NOTE.bold}</strong> {CONFIG_NOTE.text}
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
